<mat-card appearance="outlined">
   <ngx-spinner [zIndex]="100" name="spExpedienteVinculado" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>
  <mat-toolbar>
    <mat-card-header>
      <mat-card-title>Expedientes vinculados</mat-card-title>
      <mat-card-subtitle>a este expediente</mat-card-subtitle>
    </mat-card-header>
    <span class="example-spacer"></span>
    <button mat-icon-button class="example-icon" matTooltip="Vincular expediente" aria-label="Vincular expediente" (click)="openDialog({ accion: accionesDialog.Agregar})">
      <mat-icon>add</mat-icon>
    </button>
    <button mat-icon-button matTooltip="Desvincular expedientes seleccioados" *ngIf="expedienteVinculadoCount.selectedOptions.selected.length > 0" class="example-icon"
      aria-label="Desvincular expedientes seleccioados" (click)="desvincularExpedientes()">
      <mat-icon>delete</mat-icon>
    </button>
  </mat-toolbar>
  <mat-card-content>
    <mat-selection-list #expedienteVinculadoCount>
      <mat-list-option *ngFor="let expedienteVinculado of expedientesVinculados; let i = index" [value]="i">
        {{expedienteVinculado?.expediente?.caratula | uppercase}}
      </mat-list-option>
    </mat-selection-list>
  </mat-card-content>
</mat-card>
